import { memo, useEffect, useMemo, useState } from "react";
import RemotePatientWrapper from "./Controller/PatientUi";

function App() {
  return <RemotePatientWrapper />;
}

export default memo(App);
